import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Home from "./Pages/Home";
import Cart from "./Pages/Cart";
import ProfilePage from "./Pages/ProfilePage";
import ProfileHome from "./Components/Profile/ProfileHome.jsx";
import Settings from "./Components/Profile/Settings.jsx";
import Myorder from "./Components/Profile/Myorder.jsx";
import Return from "./Components/Profile/Returns.jsx";
import EesouqCredits from "./Components/Profile/EesouqCredits.jsx";
import Payments from "./Components/Profile/Payments.jsx";
import Wishlist from "./Components/Profile/Wishlist.jsx";
import Addresses from "./Components/Profile/Addresses.jsx";
import ProductDetailsFinal from "./Components/ProductDetails/ProductDetailsFinal.jsx";
import Category from "./Pages/Category.jsx";
import Category2 from "./Pages/Category2.jsx";
import Login from "./Pages/Login.jsx";
import Checkout from "./Pages/Checkout.jsx";
import AddressPage from "./Components/AddressPage.jsx";
import WishlistHome from "./HomeComponents/WishlistHome.jsx";
import OrderDetails from "./Components/Profile/OrderDetails.jsx";
import OrderSuccessfullpage from "./Components/OrderSuccessfullpage.jsx";
import PopupMessage from "./Components/PopupMessage.jsx";
import About from "./Pages/About.jsx";
import PrivacyPolicy from './Pages/PrivacyPolicy.jsx';
import TermsAndConditions from "./Pages/TermsAndConditions .jsx";
import ReturnPolicy from "./Pages/ReturnPolicy.jsx";
import ContactUs from "./Pages/ContactUs .jsx";
import ScrollToTop from "./scrolltotop.js";


function App() {
  return (
    <Router future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <ScrollToTop/>
      <PopupMessage />
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route path="profile" element={<ProfilePage />}>
          <Route index element={<ProfileHome />} />
          <Route path="update" element={<ProfileHome />} />
          <Route path="myorders" element={<Myorder />} />
          <Route path="settings" element={<Settings />} />
          <Route path="returns" element={<Return />} />
          <Route path="esooq-credits" element={<EesouqCredits />} />
          <Route path="payments" element={<Payments />} />
          <Route path="address" element={<Addresses />} />
          <Route path="wishlist" element={<Wishlist />} />
        </Route>

        <Route path="/product_details_final/:product_url" element={<ProductDetailsFinal />} />
        <Route path="/orderDetails/:tracking_id" element={<OrderDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/category/:categoryName" element={<Category />} />
        <Route path="/subcategory/:subcategoryName" element={<Category2 />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/addresspage" element={<AddressPage/>}/>
        <Route path="wishlistHome" element={<WishlistHome />} />
        <Route path="/successfullyorderplaced/:tracking_id" element={<OrderSuccessfullpage />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        
        {/* Catch-all route for 404 Not Found */}
        <Route path="*" element={<h1>404 Not Found</h1>} />

        
        {/* Fallback route for unmatched paths */}


       
      </Routes>
    </Router>
  );
}

export default App;

